/**
 * @generated SignedSource<<e1b2b5e25ac529c99607f60bb2f42d14>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type EstimateDeclineReason = "FOUND_OTHER_SUPPLIER" | "NO_MORE_DEMAND" | "OTHER_REASON" | "PRICE_TOO_HIGH" | "QUALITY_TOO_LOW" | "%future added value";
export type EstimateStatus = "ACCEPTED" | "COMPLETED" | "DECLINED" | "DRAFT" | "SENT" | "%future added value";
export type DeclineEstimateInput = {
  note?: string | null | undefined;
  reason: EstimateDeclineReason;
  webToken: string;
};
export type DeclineEstimateMutation$variables = {
  input: DeclineEstimateInput;
};
export type DeclineEstimateMutation$data = {
  readonly declineEstimate: {
    readonly estimate: {
      readonly id: string;
      readonly status: EstimateStatus;
    } | null | undefined;
  } | null | undefined;
};
export type DeclineEstimateMutation = {
  response: DeclineEstimateMutation$data;
  variables: DeclineEstimateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeclineEstimatePayload",
    "kind": "LinkedField",
    "name": "declineEstimate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Estimate",
        "kind": "LinkedField",
        "name": "estimate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeclineEstimateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeclineEstimateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "183f2427a89faa46a762f9b8bf0bde9b",
    "id": null,
    "metadata": {},
    "name": "DeclineEstimateMutation",
    "operationKind": "mutation",
    "text": "mutation DeclineEstimateMutation(\n  $input: DeclineEstimateInput!\n) {\n  declineEstimate(input: $input) {\n    estimate {\n      id\n      status\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "16eec8c60487d102bdaa055d73b915a8";

export default node;
